import {
  ArticleOutlined,
  FacebookRounded,
  Instagram,
  Twitter,
} from "@mui/icons-material";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { CircularProgress } from "@mui/material";

import styles from "./CardDetailCalon.module.css";

function CardDetailCalon({
  isLoading,
  setMedsos,
  medsos,
  dataCalon,
  image,
  nama,
}) {

  const renderContent = (platformIndex, platformKey, emptyMessage) => {
    return (
      dataCalon[platformIndex] &&
      medsos === platformKey &&
      (dataCalon[platformIndex].data.length > 0 ? (
        dataCalon[platformIndex].data.map((item, idx) => (
          <a
            href={item.link_content}
            target="_blank"
            rel="noreferrer"
            key={idx}
          >
            <div className={styles.article}>{item.content}</div>
          </a>
        ))
      ) : (
        <div className={styles.article}>{emptyMessage}</div>
      ))
    );
  };

  return (
    <div className={styles.card_person}>
      <div className={styles.header_person_container}>
        <div className={styles.title_person}>
          <img src={image} alt={nama} />
        </div>
        <div className={styles.container}>
          <div className={styles.wrapper_name}>
            <h4>{nama}</h4>
          </div>
          <div className={styles.social_media}>
            {dataCalon[3] && (
              <div
                className={
                  medsos === "article" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("article")}
              >
                <ArticleOutlined fontSize={"medium"} />
              </div>
            )}
            {dataCalon[2] && (
              <div
                className={
                  medsos === "fb" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("fb")}
              >
                <FacebookRounded fontSize={"medium"} />
              </div>
            )}
            {dataCalon[0] && (
              <div
                className={
                  medsos === "twitter" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("twitter")}
              >
                <Twitter fontSize={"medium"} />
              </div>
            )}
            {dataCalon[1] && (
              <div
                className={
                  medsos === "ig" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("ig")}
              >
                <Instagram fontSize={"medium"} />
              </div>
            )}
            {dataCalon[4] && (
              <div
                className={
                  medsos === "tiktok" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("tiktok")}
              >
                <MusicNoteIcon fontSize={"medium"} />
              </div>
            )}
            {dataCalon[5] && (
              <div
                className={
                  medsos === "threads" ? "icon-sosial active" : "icon-sosial"
                }
                onClick={() => setMedsos("threads")}
              >
                <AlternateEmailIcon fontSize={"medium"} />
              </div>
            )}
          </div>
          <div className={styles.numfound_wrapper}>
            {dataCalon[3] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "article" ? styles.active : ""
                }`}
              >
                {dataCalon[3].numFound}
              </div>
            )}
            {dataCalon[2] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "fb" ? styles.active : ""
                }`}
              >
                {dataCalon[2].numFound}
              </div>
            )}
            {dataCalon[0] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "twitter" ? styles.active : ""
                }`}
              >
                {dataCalon[0].numFound}
              </div>
            )}
            {dataCalon[1] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "ig" ? styles.active : ""
                }`}
              >
                {dataCalon[1].numFound}
              </div>
            )}
            {dataCalon[4] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "tiktok" ? styles.active : ""
                }`}
              >
                {dataCalon[4].numFound}
              </div>
            )}
            {dataCalon[5] && (
              <div
                className={`${styles.numfound} ${
                  medsos === "threads" ? styles.active : ""
                }`}
              >
                {dataCalon[5].numFound}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.contents_person}>
        <div className={styles.content_article}>
          {isLoading && (
            <div className={styles.isLoading}>
              <CircularProgress size={80} />
            </div>
          )}

          {renderContent(3, "article", "No articles yet")}
          {renderContent(2, "fb", "No Facebook posts yet")}
          {renderContent(1, "ig", "No Instagram posts yet")}
          {renderContent(0, "twitter", "No Tweets yet")}
          {renderContent(4, "tiktok", "No Tiktok posts yet")}
          {renderContent(5, "threads", "No Threads posts yet")}

          {!(
            (dataCalon[3] && dataCalon[3].data.length > 0) ||
            (dataCalon[2] && dataCalon[2].data.length > 0) ||
            (dataCalon[1] && dataCalon[1].data.length > 0) ||
            (dataCalon[0] && dataCalon[0].data.length > 0) ||
            (dataCalon[4] && dataCalon[4].data.length > 0) ||
            (dataCalon[5] && dataCalon[5].data.length > 0)
          ) &&
            !isLoading && (
              <div className={styles.article}>No content available</div>
            )}
        </div>
      </div>
    </div>
  );
}

export default CardDetailCalon;
